function GetUTCNow() {
  var date = new Date();
  var now_utc = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(),
  date.getHours(), date.getMinutes(), date.getSeconds());
  return Number(now_utc/1000);
}

function GetDateStr(date){
  return moment(date).format("YYYY-MM-DD");
}

function GetMobileMonthFormat(month) {
  //Momentjs use 0 based indexing for month
  if (month == 0) {
    return 'Jan';
  } else if (month == 1) {
    return 'Feb';
  } else if (month == 2) {
    return 'Mar';
  } else if (month == 3) {
    return 'Apr';
  } else if (month == 4) {
    return 'May';
  } else if (month == 5) {
    return 'Jun';
  } else if (month == 6) {
    return 'Jul';
  } else if (month == 7) {
    return 'Aug';
  } else if (month == 8) {
    return 'Sep';
  } else if (month == 9) {
    return 'Oct';
  } else if (month == 10) {
    return 'Nov';
  } else if (month == 11) {
    return 'Dec';
  }
}

function UpdateMobileMapTime(startUnix, endUnix){
  //.format("YYYY-MM-DD hh:mm a")
  startMoment = moment.tz(startUnix * 1000, "Etc/UTC")
  endMoment = moment.tz(endUnix * 1000, "Etc/UTC")
  console.log(`${GetMobileMonthFormat(startMoment.month())} ${startMoment.format("D")} ${startMoment.format("h:mm a")}`)
  if(startMoment.isSame(new Date(), "day")){
    $('.search-toolbar-button-datetime-start .search-toolbar-button-date').empty().text('Today');
  } else {
    $('.search-toolbar-button-datetime-start .search-toolbar-button-date').empty().text(`${GetMobileMonthFormat(startMoment.month())} ${startMoment.format("D")}`);
  }

  if(endMoment.isSame(new Date(), "day")){
    $('.search-toolbar-button-datetime-end .search-toolbar-button-date').empty().text('Today');
  } else {
    $('.search-toolbar-button-datetime-end .search-toolbar-button-date').empty().text(`${GetMobileMonthFormat(endMoment.month())} ${endMoment.format("D")}`);
  }


  $('.search-toolbar-button-datetime-start .search-toolbar-button-time').empty().text(startMoment.format("h:mm a"));
  $('.search-toolbar-button-datetime-end .search-toolbar-button-time').empty().text(endMoment.format("h:mm a"));

}

function GetTimeNearest30(date){
  m = moment(date);
  if (m.minute() > 30) {
    m.minute(30)
  } else {
    m.minute(0)
  }
  return m.format("hh:mm a");
}

function GetTimeStr(date){
  return moment(date).format("hh:mm a");
}

function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

function calculateHourlyPrice(thisForm) {
  var thisForm = thisForm;

  // show loading animation
  $('.wmw-card-overlay', thisForm).show();
  $('.sf-radio-buttons input[type="radio"]', thisForm).prop('disabled', true);

  // get variables
  var facilityId = $('#facility-id').val();
  var startDate = $('#start-date').val();
  var startTime = $('#start-time').val();
  var endDate = $('#end-date').val();
  var endTime = $('#end-time').val();
  var offset = Number($('#offset').val());
  var promoCode = $('#promo-code').val();

  if (offset == 0) {

    var offsetISO8601 = '+00:00';

  } else {

    var offsetWIP = ((offset / 60) / 60) * 100;
    var offsetHours = offsetWIP.toString().slice(0, -2);
    var isNegative = offsetHours.indexOf('-');
    if (isNegative == 0) {
      if (offsetHours.length < 3) {
        offsetHours = offsetHours.substring(1);
        offsetHours = '-0' + offsetHours;
      }
    } else {
      if (offsetHours.length < 2) {
        offsetHours = '+0' + offsetHours;
      } else {
        offsetHours = '+' + offsetHours;
      }
    }
    var offsetMinutes = offsetWIP.toString().slice(-2);
    var offsetISO8601 = offsetHours + ':' + offsetMinutes;

  }

  offsetISO8601 = '+00:00';
  // convert dates and times to unix epoch format
  var startDateTime = new Date(startDate + 'T' + startTime + offsetISO8601).getTime() / 1000;
  var endDateTime = new Date(endDate + 'T' + endTime + offsetISO8601).getTime() / 1000;
  var nowDateTime = GetUTCNow();

  if (startDateTime < (nowDateTime - (60 * 40))) {

    // disable checkout on error
    $('.button-spinner', thisForm).prop('disabled', true);
    // hide loading animation
    $('.wmw-card-overlay', thisForm).hide();
    $('.form-card-message', thisForm).removeClass('form-card-message-success').addClass('form-card-message-error').text('Start date/time is in the past.');

  } else if (endDateTime < nowDateTime) {

    // disable checkout on error
    $('.button-spinner', thisForm).prop('disabled', true);
    // hide loading animation
    $('.wmw-card-overlay', thisForm).hide();
    $('.sf-radio-buttons input[type="radio"]', thisForm).prop('disabled', false);
    $('.form-card-message', thisForm).removeClass('form-card-message-success').addClass('form-card-message-error').text('End date/time is in the past.');

  } else if (startDateTime >= endDateTime) {

    // startDateTime is greater than or equal to endDateTime
    var difference = startDateTime - endDateTime;
    // console.log(difference);
    // disable checkout on error
    $('.button-spinner', thisForm).prop('disabled', true);
    // hide loading animation
    $('.wmw-card-overlay', thisForm).hide();
    $('.sf-radio-buttons input[type="radio"]', thisForm).prop('disabled', false);
    $('.form-card-message', thisForm).removeClass('form-card-message-success').addClass('form-card-message-error').text('End date/time is earlier than start date/time.');

  } else {

    // endDateTime is greater than startDateTime, proceed!
    $('.form-card-message', thisForm).removeClass('form-card-message-error').empty();

    $.ajax({
      type: 'post',
      url: '/wp-admin/admin-ajax.php',
      data: {
        action: 'calculate_hourly_price',
        facilityId: facilityId,
        startDateTime: startDateTime,
        endDateTime: endDateTime,
        nowDateTime: nowDateTime,
        promoCode: promoCode
      },
      success: function (results) {
        var results = $.parseJSON(results);
        console.log(results);
        if (results.status == 'success') {

          // enable checkout (if disabled) on success
          $('.button-spinner', thisForm).prop('disabled', false);
          // update hidden price field in pennies
          $('#price').val(results['new_price']);
          // update display price field in dollars
          $('#display-price').text(results['new_price'] / 100);
          $('.form-card-message', thisForm).removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);

        } else {

          $('.form-card-message', thisForm).removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);
          // disable checkout on error
          $('.button-spinner', thisForm).prop('disabled', false);

        }
        // hide loading animation
        $('.wmw-card-overlay', thisForm).hide();
        $('.sf-radio-buttons input[type="radio"]', thisForm).prop('disabled', false);
      },
      error: function (results) {
        var results = $.parseJSON(results);
        console.log(results);
        // hide loading animation
        $('.wmw-card-overlay', thisForm).hide();
        $('.sf-radio-buttons input[type="radio"]', thisForm).prop('disabled', false);
        $('.button-spinner', thisForm).prop('disabled', false);
      }
    });
  }
}

function calculateQuantityChange(parkingType) {
  var parkingType = parkingType;
  $('#quantity').change(function(){
    if (parkingType == 'monthly') {
      calculateMonthlyPrice();
    } else if (parkingType == 'coupon') {
      calculateCouponPrice();
    }
  });
}

$(document).ready(function(){

  // initialize slideshow of facility photos
  facilityPhotos();

  // tabs functionality
  $('.wmw-card-tabs').each(function(){
    $('.wmw-card-tabs-nav li').click(function(){
      var thisTab = $(this).attr('data-tab');
      // hide all tabs
      $('.wmw-card-tabs-nav li').removeClass('wmw-card-tab-active');
      $('.wmw-card-tab').removeClass('wmw-card-tab-active');
      // show chosen tab
      $(this).addClass('wmw-card-tab-active');
      $('.wmw-card-tab[data-tab="' + thisTab + '"]').addClass('wmw-card-tab-active');
    });
  });

  if ($('#sf-pre-checkout').length) {
    var thisForm = $('#sf-pre-checkout');

    // get current date and time, rounded to nearest 30 minutes
    var date = new Date();
    var startDate = GetDateStr(date);
    var startTime = GetTimeNearest30(date);
    var startTime = moment(startTime, ['hh:mm a']).format('HH:mm');

    var date = moment(date).add(3, 'hours');
    var endDate = GetDateStr(date);
    var endTime = GetTimeNearest30(date);
    var endTime = moment(endTime, ['hh:mm a']).format('HH:mm');

    console.log(startDate, startTime, endDate, endTime);

    $('#start-date', thisForm).val(startDate);
    $('#start-time', thisForm).val(startTime);
    $('#end-date', thisForm).val(endDate);
    $('#end-time', thisForm).val(endTime);
    $('#start-date-monthly', thisForm).val(startDate);

    // calculate correct price on page load
    var parkingType = $('input[name="sf-parking-type"]').val();
    if (parkingType == 'hourly') {
      calculateHourlyPrice(thisForm);
    } else if (parkingType == 'monthly') {
      calculateMonthlyPrice();
      calculateQuantityChange(parkingType);
    } else if (parkingType == 'coupon') {
      calculateCouponPrice();
      calculateQuantityChange(parkingType);
    }

    // re-calculate price on start and end dates or times
    $('#start-date, #start-time, #end-date, #end-time').change(function(){
      calculateHourlyPrice(thisForm);
    });

    // show/hide form fields and calculate prices on parkingType change
    $('input[name="sf-parking-type"]').change(function(){
      var parkingType = $(this).val();
      $('.form-field-optional', thisForm).hide();
      $('.form-field-' + parkingType).show();
      if (parkingType == 'hourly') {
        $('.form-card-message', thisForm).empty();
        calculateHourlyPrice(thisForm);
      } else if (parkingType == 'monthly') {
        $('.form-card-message', thisForm).empty();
        calculateMonthlyPrice();
        calculateQuantityChange(parkingType);
      } else if (parkingType == 'coupon') {
        $('.form-card-message', thisForm).empty();
        calculateCouponPrice();
        calculateQuantityChange(parkingType);
      }
    });

    // calculate prices on monthly product change
    $('form').on('change', 'input[name="monthly-options"]', function() {
      calculateMonthlyPrice();
    });

    // calculate prices on coupon product change
    $('form').on('change', 'input[name="coupon-options"]', function() {
      calculateCouponPrice();
    });

    // apply promo code on button click
    $('#apply-promo-code').click(function(e){
      e.preventDefault();

      // show loading animation
      $('.wmw-card-overlay', thisForm).show();
      $('.sf-radio-buttons input[type="radio"]', thisForm).prop('disabled', true);
      $('.form-card-message', thisForm).empty();

      var promoCode = $('#promo-code').val();

      if (promoCode) {

        var parkingType = $('input[name="sf-parking-type"]:checked').val();

        if (parkingType == 'hourly') {

          calculateHourlyPrice(thisForm);

        } else if (parkingType == 'monthly' || parkingType == 'coupon') {

          var facilityId = $('#facility-id').val();

          $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'calculate_product_price',
              facilityId: facilityId,
              parkingType: parkingType,
              promoCode: promoCode
            },
            success: function(results) {
              var results = $.parseJSON(results);
              console.log(results);

              if (results.status == 'success') {

                // remove default options, replace with promo code product
                if (parkingType == 'monthly') {
                  $('.radio-buttons-group-monthly', thisForm).empty().append(results.productTemplate);
                } else if (parkingType == 'coupon') {
                  $('.radio-buttons-group-coupon', thisForm).empty().append(results.productTemplate);
                }

                // update price to promo code price
                var displayPrice = results.productsArray[0].product_price;
                var stripePrice = displayPrice * 100;
                $('#display-price').text(displayPrice);
                $('#price').val(stripePrice);

                $('.form-card-message').empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);

              } else {

                $('.form-card-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);

              }

              // remove loading overlay
              $('.wmw-card-overlay', thisForm).hide();
              $('.sf-radio-buttons input[type="radio"]', thisForm).prop('disabled', false);

            },
            error: function(results) {
              var results = $.parseJSON(results);
              console.log(results);

              $('.form-card-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Hmm, something didn\'t work.');

              // remove loading overlay
              $('.wmw-card-overlay', thisForm).hide();
              $('.sf-radio-buttons input[type="radio"]', thisForm).prop('disabled', false);

            }
          });

        }

      } else {

        $('.wmw-card-overlay', thisForm).hide();
        $('.sf-radio-buttons input[type="radio"]', thisForm).prop('disabled', false);
        $('.form-card-message', thisForm).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Please enter a promo code.');

      }

    });

    // apply promo code when done typing
    var recalculatePrice = debounce(function(){

      // show loading animation
      $('.wmw-card-overlay', thisForm).show();
      $('.sf-radio-buttons input[type="radio"]', thisForm).prop('disabled', true);
      $('.form-card-message', thisForm).empty();

      var promoCode = $('#promo-code').val();

      if (promoCode) {

        var parkingType = $('input[name="sf-parking-type"]:checked').val();

        if (parkingType == 'hourly') {

          calculateHourlyPrice(thisForm);

        } else if (parkingType == 'monthly' || parkingType == 'coupon') {

          var facilityId = $('#facility-id').val();

          $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'calculate_product_price',
              facilityId: facilityId,
              parkingType: parkingType,
              promoCode: promoCode
            },
            success: function(results) {
              var results = $.parseJSON(results);
              console.log(results);

              if (results.status == 'success') {

                // remove default options, replace with promo code product
                if (parkingType == 'monthly') {
                  $('.radio-buttons-group-monthly', thisForm).empty().append(results.productTemplate);
                } else if (parkingType == 'coupon') {
                  $('.radio-buttons-group-coupon', thisForm).empty().append(results.productTemplate);
                }

                // update price to promo code price
                var displayPrice = results.productPrice;
                var stripePrice = displayPrice * 100;
                $('#display-price').text(displayPrice);
                $('#price').val(stripePrice);

                $('.form-card-message').empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);

              } else {

                $('.form-card-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);

              }

              // remove loading overlay
              $('.wmw-card-overlay', thisForm).hide();
              $('.sf-radio-buttons input[type="radio"]', thisForm).prop('disabled', false);

            },
            error: function(results) {
              var results = $.parseJSON(results);
              console.log(results);

              $('.form-card-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Hmm, something didn\'t work.');

              // remove loading overlay
              $('.wmw-card-overlay', thisForm).hide();
              $('.sf-radio-buttons input[type="radio"]', thisForm).prop('disabled', false);

            }
          });

        }

      } else {

        $('.wmw-card-overlay', thisForm).hide();
        $('.sf-radio-buttons input[type="radio"]', thisForm).prop('disabled', false);
        $('.form-card-message', thisForm).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Please enter a promo code.');

      }

    }, 500);

    $('#promo-code').on('change', recalculatePrice);

    // submit the form
    $(thisForm).validate({
      // debug: true,
      errorElement: 'span',
      errorClass: 'form-field-error',
      validClass: 'form-field-valid',
      errorPlacement: function (error, element) {
        error.appendTo(element.parents('.form-field'));
      },
      highlight: function (element, errorClass, validClass) {
        $(element).parents('.form-field').addClass(errorClass).removeClass(validClass);
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).parents('.form-field').removeClass(errorClass).addClass(validClass);
      },
      rules: {
        'quantity': {
          required: true,
          number: true,
          min: '1'
        }
      },
      messages: {
        'quantity': {
          required: 'Please enter a quantity.',
          number: 'Quantity must be a number.',
          min: 'Quantity must be at least 1.'
        }
      },
      submitHandler: function(form) {

        var parkingType = $('input[type="radio"][name="sf-parking-type"]:checked').val();

        var timezone = $('#timezone').val();
        var offset = Number($('#offset').val());
        if (offset == 0) {

          var offsetISO8601 = '+00:00';

        } else {

          var offsetWIP = ((offset / 60) / 60) * 100;
          var offsetHours = offsetWIP.toString().slice(0, -2);
          var isNegative = offsetHours.indexOf('-');
          if (isNegative == 0) {
            if (offsetHours.length < 3) {
              offsetHours = offsetHours.substring(1);
              offsetHours = '-0' + offsetHours;
            }
          } else {
            if (offsetHours.length < 2) {
              offsetHours = '+0' + offsetHours;
            } else {
              offsetHours = '+' + offsetHours;
            }
          }
          var offsetMinutes = offsetWIP.toString().slice(-2);
          var offsetISO8601 = offsetHours + ':' + offsetMinutes;

        }

        if (parkingType == 'hourly') {

          var startDate = $('#start-date').val();
          var startTime = $('#start-time').val();
          var endDate = $('#end-date').val();
          var endTime = $('#end-time').val();
          var promoCode = $('#promo-code').val();
          var price = $('#price').val();

          offsetISO8601 = '+00:00';
          var startDateTime = new Date(startDate + 'T' + startTime + offsetISO8601).getTime() / 1000;
          var endDateTime = new Date(endDate + 'T' + endTime + offsetISO8601).getTime() / 1000;

          if (promoCode) {

            window.location.href = '/?checkout=true&type=hourly&startTime=' + startDateTime + '&endTime=' + endDateTime + '&promoCode=' + promoCode + '&expectedPrice=' + price;

          } else {

            window.location.href = '/?checkout=true&type=hourly&startTime=' + startDateTime + '&endTime=' + endDateTime + '&expectedPrice=' + price;

          }

        } else if (parkingType == 'monthly') {

          var monthlyProduct = $('input[name="monthly-options"]:checked').val();
          var startDate = $('#start-date-monthly').val();
          var startTime = $('#start-time-monthly').val();
          var quantity = $('#quantity').val();
          var promoCode = $('#promo-code').val();
          var price = $('#price').val();

          var startDateTime = new Date(startDate + 'T' + startTime + offsetISO8601).getTime() / 1000;

          if (promoCode) {

            window.location.href = '/?checkout=true&type=monthly&startTime=' + startDateTime + '&productId=' + monthlyProduct + '&quantity=' + quantity + '&promoCode=' + promoCode;

          } else {

            window.location.href = '/?checkout=true&type=monthly&startTime=' + startDateTime + '&productId=' + monthlyProduct + '&quantity=' + quantity;

          }

        } else if (parkingType == 'coupon') {

          var couponProduct = $('input[name="coupon-options"]:checked').val();
          var quantity = $('#quantity').val();
          var promoCode = $('#promo-code').val();
          var price = $('#price').val();

          if (promoCode) {

            window.location.href = '/?checkout=true&type=coupon&productId=' + couponProduct + '&quantity=' + quantity + '&promoCode=' + promoCode;

          } else {

            window.location.href = '/?checkout=true&type=coupon&productId=' + couponProduct + '&quantity=' + quantity;

          }

        }

      }
    });
  }

  /*** checkout! ***/
  var checkout = getUrlParameter('checkout');
  if (checkout == 'true') {

    var type = getUrlParameter('type');
    var expectedPrice = getUrlParameter('expectedPrice');
    var promoCode = getUrlParameter('promoCode');

    if (type == 'hourly') {

      if (expectedPrice == 0) {

        calculateHourlyPrice($('#reservation-summary'));

      }

      // re-calculate price on start and end dates or times
      $('#start-date, #start-time, #end-date, #end-time').change(function(){
        calculateHourlyPrice($('#reservation-summary'));
      });

    } else if (type == 'monthly') {

      // calculate prices on page load
      calculateMonthlyPrice();

      // calculate prices on monthly product change
      $('input[name="monthly-options"]').change(function(){
        calculateMonthlyPrice();
      });

    } else if (type == 'coupon') {

      // calculate prices on page load
      calculateCouponPrice()

      // calculate prices on coupon product change
      $('input[name="coupon-options"]').change(function(){
        calculateCouponPrice();
      });

    }

    // apply promo code on button click
    $('#apply-promo-code').click(function(e){
      e.preventDefault();

      thisForm = $('#reservation-summary');

      // show loading animation
      $('.wmw-card-overlay', thisForm).show();
      $('.form-card-message', thisForm).empty();

      var promoCode = $('#promo-code').val();

      if (promoCode) {

        if (type == 'hourly') {

          calculateHourlyPrice(thisForm);

        } else if (type == 'monthly' || type == 'coupon') {

          var facilityId = $('#facility-id').val();

          $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'calculate_product_price',
              facilityId: facilityId,
              parkingType: type,
              promoCode: promoCode
            },
            success: function(results) {
              var results = $.parseJSON(results);
              console.log(results);

              if (results.status == 'success') {

                // remove default options, replace with promo code product
                if (type == 'monthly') {
                  $('.radio-buttons-group-monthly', thisForm).empty().append(results.productTemplate);
                } else if (type == 'coupon') {
                  $('.radio-buttons-group-coupon', thisForm).empty().append(results.productTemplate);
                }

                // update price to promo code price
                var displayPrice = results.productPrice;
                var stripePrice = displayPrice * 100;
                $('#display-price').text(displayPrice);
                $('#price').val(stripePrice);

                $('.form-card-message').empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);

              } else {

                $('.form-card-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);

              }

              // remove loading overlay
              $('.wmw-card-overlay', thisForm).hide();

            },
            error: function(results) {
              var results = $.parseJSON(results);
              console.log(results);

              $('.form-card-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Hmm, something didn\'t work.');

              // remove loading overlay
              $('.wmw-card-overlay', thisForm).hide();

            }
          });

        }

      } else {

        $('.wmw-card-overlay', thisForm).hide();
        $('.form-card-message', thisForm).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Please enter a promo code.');

      }

    });

    // apply promo code when done typing
    var recalculatePrice = debounce(function(){

      thisForm = $('#reservation-summary');

      // show loading animation
      $('.wmw-card-overlay', thisForm).show();
      $('.form-card-message', thisForm).empty();

      var promoCode = $('#promo-code').val();

      if (promoCode) {

        if (type == 'hourly') {

          calculateHourlyPrice(thisForm);

        } else if (type == 'monthly' || type == 'coupon') {

          var facilityId = $('#facility-id').val();

          $.ajax({
            type: 'post',
            url: '/wp-admin/admin-ajax.php',
            data: {
              action: 'calculate_product_price',
              facilityId: facilityId,
              parkingType: type,
              promoCode: promoCode
            },
            success: function(results) {
              var results = $.parseJSON(results);
              console.log(results);

              if (results.status == 'success') {

                // remove default options, replace with promo code product
                if (type == 'monthly') {
                  $('.radio-buttons-group-monthly', thisForm).empty().append(results.productTemplate);
                } else if (type == 'coupon') {
                  $('.radio-buttons-group-coupon', thisForm).empty().append(results.productTemplate);
                }

                // update price to promo code price
                var displayPrice = results.productPrice;
                var stripePrice = displayPrice * 100;
                $('#display-price').text(displayPrice);
                $('#price').val(stripePrice);

                $('.form-card-message').empty().removeClass('form-card-message-error').addClass('form-card-message-success').text(results.message);

              } else {

                $('.form-card-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text(results.message);

              }

              // remove loading overlay
              $('.wmw-card-overlay', thisForm).hide();

            },
            error: function(results) {
              var results = $.parseJSON(results);
              console.log(results);

              $('.form-card-message').empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Hmm, something didn\'t work.');

              // remove loading overlay
              $('.wmw-card-overlay', thisForm).hide();

            }
          });

        }

      } else {

        $('.wmw-card-overlay', thisForm).hide();
        $('.form-card-message', thisForm).empty().removeClass('form-card-message-success').addClass('form-card-message-error').text('Please enter a promo code.');

      }

    }, 500);

    $('#promo-code').on('change', recalculatePrice);

  }

  /*** google maps ***/
  if ($('#map').length) {
    var latitude = $('#map').attr('data-latitude');
    var longitude = $('#map').attr('data-longitude');
    var mapId = 'map';

    var myLatLng = new google.maps.LatLng(latitude, longitude);

    var browserWidth = $(window).width();
    if (browserWidth > 799) {
      var latitudeOffset = parseFloat(latitude) + 0.002;
      var longitudeOffset = parseFloat(longitude) + 0.007;
      var centerLatLng = new google.maps.LatLng(latitude, longitudeOffset);
    } else {
      var centerLatLng = new google.maps.LatLng(latitude, longitude);
    }

    var mapOptions = {
      zoom: 16,
      center: centerLatLng,
      draggable: false,
      disableDefaultUI: true,
      clickableIcons: false,
      styles: [
        {
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#f5f5f5"
            }
          ]
        },
        {
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#616161"
            }
          ]
        },
        {
          "elementType": "labels.text.stroke",
          "stylers": [
            {
              "color": "#f5f5f5"
            }
          ]
        },
        {
          "featureType": "administrative.land_parcel",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#bdbdbd"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#eeeeee"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#e5e5e5"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#dadada"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#616161"
            }
          ]
        },
        {
          "featureType": "road.local",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        },
        {
          "featureType": "transit.line",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#e5e5e5"
            }
          ]
        },
        {
          "featureType": "transit.station",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#eeeeee"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#c9c9c9"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        }
      ]
    };
    var map = new google.maps.Map(document.getElementById(mapId), mapOptions);

    var marker = new google.maps.Marker({
      position: myLatLng,
      map: map
    });

    google.maps.event.addDomListener(window, 'resize', function(){
      var browserWidth = $(window).width();
      if (browserWidth > 799) {
        var latitudeOffset = parseFloat(latitude) + 0.002;
        var longitudeOffset = parseFloat(longitude) + 0.007;
        var centerLatLng = new google.maps.LatLng(latitude, longitudeOffset);
      } else {
        var centerLatLng = new google.maps.LatLng(latitude, longitude);
      }
      map.setCenter(centerLatLng);
    });

  }

});


